module.exports = __webpack_public_path__ + "static/media/Whatsapp.cdfb6ff3.svg";